import {Inject, PLATFORM_ID, Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { isPlatformBrowser,isPlatformServer } from '@angular/common';
import { environment } from '../../environments/environment';
import { TextSetting } from '../textsetting';
import { UserService } from '../_services/user.service';
@Injectable()
export class JobseekerAuthGuard implements CanActivate {
	env		=	environment;
	TextSetting		=	TextSetting;
	constructor(private router: Router, @Inject(PLATFORM_ID) private platformId: object, private userService: UserService) { }
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): any {
		if(isPlatformServer(this.platformId)){
			return true;
		}else{
			const currentUser 	=	this.userService.getCurrentUser();
			if (typeof currentUser.jobseeker !== 'undefined' && currentUser.jobseeker) {
				return true;
			}else{
				this.router.navigate(['/']);
				return false;
			}
		}
	}

}
